import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import type { ConfigTypeName } from '../config/configuration-types.js'
import { ConfigTypes } from '../config/configuration-types.js'
import { BoVisitor } from './bo-visitor.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	ConfigurationItemProperty,
	ConfigItemSelectionOption,
} from './configuration-item-property.js'

// Re-export for external use
export { ConfigurationItemProperty, ConfigItemSelectionOption }

export const ConfigurationItemScopes = ['cluster', 'server'] as const

@jsonClass('ConfigurationItem')
export class ConfigurationItem extends BusinessObject {
	@jsonProperty(String)
	type: ConfigTypeName = 'blank'
	@jsonArrayProperty(ConfigurationItemProperty)
	properties: ConfigurationItemProperty[] = []

	constructor(init?: Partial<ConfigurationItem>) {
		super()
		assignCommonProperties(this, init)
	}

	getPredefinedProperties() {
		return ConfigTypes[this.type]?.properties ?? []
	}

	getEffectiveProperties() {
		return [...this.getPredefinedProperties(), ...this.properties]
	}

	getClassNames(): string[] {
		return ['$Config']
	}

	visit(visitor: BoVisitor): void {
		// visitor.visitTsCode(this.tsType, this, 'type', ['type'], newType => this.tsType = newType)
	}
}
